<template>
    <div>
        <q-score-card key="QScoreCardQuilityRxCompensable" ref="card" title="Compensable" api-endpoint="rx_compensable" drill-down-label="Agent Breakdown" drill-down-route="Drilldown_QuilityRxCompensable" card-style="recruiting" :agent-code="agentCode" :filters="filters" v-on:most_current="updateMostCurrent">
            Note: How many members used the card at the pharmacy and received a discount, which will reflect towards the agent.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardQuilityRxCompensable",
    props: ["agentCode", "filters"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {},
    computed: {

    },
    methods: {
        updateMostCurrent: function(most_current) {
            this.$emit('most_current', most_current);
        }
    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
